import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { LoaderType } from '../shared/interface';
interface ILoaderProps  extends ICellRendererParams {
  type?: LoaderType;
}

const Loader = (params: ILoaderProps) => {
 let hasValue = false;
  if (params.data && typeof params.data === 'object') {
    for (const key in params.data) {
      if (params.data[key] !== undefined && params.data[key] !== null) {
        hasValue = true;
        break; 
      }
    }
  }

  hasValue = hasValue || Boolean(params.value);

  if (hasValue) {
    return <span>{params.value}</span>;
  }
  if(params.type === LoaderType.Icon) {
    return(  
      <div className="skeleton-wrapper">
        <div className="skeleton-icon" />
      </div>
     )
  }
  if (params.type === LoaderType.ActionButton) {
    return (
      <div className="skeleton-button-row">
        <div className="skeleton-button" />
        <div className="skeleton-button" />
        <div className="skeleton-button" />
      </div>
    );
  }

  if (params.type === LoaderType.Date) {
    return ( 
        <div className="skeleton-wrapper">
          <div className="skeleton-date" />
        </div>
    );
  }

  if (params.type === LoaderType.State) {
    return (
      <div className="skeleton-wrapper">
        <div className="skeleton-state">
          <div className="skeleton-line short"></div>
          <div className="skeleton-line long"></div>
        </div>
      </div>
    );
  }
  if (params.type === LoaderType.BoxShortWidth) {
    return (
      <div className="skeleton-wrapper">
        <div className="skeleton-box-short"> 
        </div>
      </div>
    );
  }
  if (params.type === LoaderType.Image) {
    return (
      <div className="skeleton-wrapper">
        <div className="skeleton-image" />
      </div>
    );
  }
  if(params.type === LoaderType.BoxFullWidth) {
    return (
      <div className="skeleton-wrapper">
        <div className="skeleton-box" />
      </div>
    );
  }


  return (
    <div className="skeleton-wrapper">
      <div className="skeleton-box" />
    </div>
  );
};

export default Loader;
